export const CREATE_INVITES = 'CREATE_INVITES'
export const CREATE_INVITES_START = 'CREATE_INVITES_START'
export const CREATE_INVITES_SUCCESS = 'CREATE_INVITES_SUCCESS'
export const CREATE_INVITES_ERROR = 'CREATE_INVITES_FAIL'

export const RESEND_INVITE = 'RESEND_INVITE'
export const RESEND_INVITE_START = 'RESEND_INVITE_START'
export const RESEND_INVITE_SUCCESS = 'RESEND_INVITE_SUCCESS'
export const RESEND_INVITE_ERROR = 'RESEND_INVITE_FAIL'

export const FETCH_INVITES = 'FETCH_INVITES'
export const FETCH_INVITES_START = 'FETCH_INVITES_START'
export const FETCH_INVITES_SUCCESS = 'FETCH_INVITES_SUCCESS'
export const FETCH_INVITES_ERROR = 'FETCH_INVITES_FAIL'

export const DELETE_INVITE = 'DELETE_INVITE'
export const DELETE_INVITE_START = 'DELETE_INVITE_START'
export const DELETE_INVITE_SUCCESS = 'DELETE_INVITE_SUCCESS'
export const DELETE_INVITE_ERROR = 'DELETE_INVITE_FAIL'
